module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"no_building":"Aucun bâtiment disponible.","select_dashboard":"Sélectionner un dashboard"},"en":{"no_building":"No building available.","select_dashboard":"Select a dashboard"}}')
  delete Component.options._Ctor
}
